<div class="container pb-50 pt-20" id="school-settings">
  <div class="row mt-20">
    <div class="col-md-3 col-lg-3">
    </div>
    <div class="col-md-8 col-lg-8">
      <app-article [pageName]="'SETTINGS'" (pageTeacherDataLoaded)="handlePageData($event)"></app-article>
    </div>

    <div class="col-md-3 col-lg-3" *ngIf="!schoolProps.properties.job_only_teacher">
      <div class="card nav__card px-15">
        <nav class="nav flex-column nav-pills pt-3" id="settings-tabs" role="tablist" aria-orientation="vertical"
          style="flex: 1 1 auto">
          <button class="nav-link text-regular-medium fs-16 text-regular-medium fs-16 active d-flex align-items-center"
            id="booking-tab" data-bs-toggle="pill" data-bs-target="#booking-content" type="button" role="tab"
            [class.active]="activeTab === 'booking-notifications'" (click)="setActiveTab('booking-notifications')">
            <span class="me-2"><i class="bi bi-bell"></i></span>
            Booking Notifications
          </button>
          <button class="nav-link text-regular-medium fs-16 d-flex align-items-center" id="job-tab"
            data-bs-toggle="pill" data-bs-target="#job-content" type="button" role="tab"
            [class.active]="activeTab === 'job-notifications'" (click)="setActiveTab('job-notifications')">
            <span class="me-2"><i class="bi bi-briefcase"></i></span>
            Job Notifications
          </button>
          <button class="nav-link text-regular-medium fs-16 d-flex align-items-center" id="account-tab"
            data-bs-toggle="pill" data-bs-target="#account-content" type="button" role="tab"
            [class.active]="activeTab === 'account-settings'" (click)="setActiveTab('account-settings')">
            <span class="me-2"><i class="bi bi-person"></i></span>
            Account Settings
          </button>
          <button class="nav-link text-regular-medium fs-16 d-flex align-items-center" id="password-tab"
            data-bs-toggle="pill" data-bs-target="#password-content" type="button" role="tab"
            [class.active]="activeTab === 'password-reset'" (click)="setActiveTab('password-reset')">
            <span class="me-2"><i class="bi bi-key"></i></span>
            Password Reset
          </button>
          <div class="alignBottom">
            <hr class="my-3" />

            <!-- <button
              class="nav-link text-regular-medium fs-16 d-flex align-items-center"
              id="support-tab"
              data-bs-toggle="pill"
              data-bs-target="#support-content"
              type="button"
              role="tab"
              [class.active]="activeTab === 'live-support-chat'"
              (click)="setActiveTab('live-support-chat')"
            >
              <span class="me-2"><i class="bi bi-chat-dots"></i></span>
              Live support chat
            </button> -->
            @if(!this.settingsData?.is_deactivated) {
            <button class="nav-link text-regular-medium fs-16 d-flex align-items-center" id="deactivate-tab"
              data-bs-toggle="pill" data-bs-target="#deactivate-content" type="button" role="tab"
              [class.active]="activeTab === 'deactivate-account'" (click)="setActiveTab('deactivate-account')">
              <span class="me-2"><i class="bi bi-person-x"></i></span>
              Deactivate my account
              <span tabindex="0" data-bs-toggle="tooltip" data-bs-placement="top"
                title="Choose this if you plan on coming back in the future and don’t want to start again">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-info-circle-fill ml-5" viewBox="0 0 16 16">
                  <title>Choose this if you plan on coming back in the future and don’t want to start again</title>
                  <path
                    d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2" />
                </svg>
              </span>
            </button>
            }@else {
            <button class="nav-link text-regular-medium fs-16 d-flex align-items-center" type="button"
              (click)="submitDeactivateAccount('activated')">
              <span class="me-2"><i class="bi bi-person-x"></i></span>
              Reactivate my account
            </button>
            }
            <button class="nav-link text-regular-medium fs-16 d-flex align-items-center" id="delete-tab"
              data-bs-toggle="pill" data-bs-target="#delete-content" type="button" role="tab"
              [class.active]="activeTab === 'delete-account'" (click)="setActiveTab('delete-account')">
              <span class="me-2"><i class="bi bi-trash"></i></span>
              Delete my account
              <span tabindex="0" data-bs-toggle="tooltip" data-bs-placement="top" title="choose this if you want all your information permanently deleted
">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-info-circle-fill ml-5" viewBox="0 0 16 16">
                  <title>Choose this if you want all your information permanently deleted
                  </title>
                  <path
                    d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2" />
                </svg>
              </span>
            </button>
          </div>
        </nav>
      </div>
    </div>
    <div class="col-md-3 col-lg-3" *ngIf="schoolProps.properties.job_only_teacher">
      <div class="card nav__card px-15">
        <nav class="nav flex-column nav-pills pt-3" id="settings-tabs" role="tablist" aria-orientation="vertical"
          style="flex: 1 1 auto">
          <button class="nav-link text-regular-medium fs-16 d-flex align-items-center" id="job-tab"
            data-bs-toggle="pill" data-bs-target="#job-content" type="button" role="tab"
            [class.active]="activeTab === 'job-notifications'" (click)="setActiveTab('job-notifications')">
            <span class="me-2"><i class="bi bi-briefcase"></i></span>
            Job Notifications
          </button>
        </nav>
      </div>
    </div>
    <div class="col-md-8 col-lg-8">

      <div class="tab-content" id="settings-tabContent">
        <div class="tab-pane fade " [ngClass]="!schoolProps.properties.job_only_teacher ? 'show active' : ''"
          id="booking-content" role="tabpanel" aria-labelledby="booking-tab">
          <form [formGroup]="bookingNotiSettings">
            <div class="card px-15">
              <p class="user-title">Booking notification</p>
              <!-- <div class="form-check mt-20">
                <input class="form-check-input c-p" type="checkbox" id="summary_mail_every_morning"
                  formControlName="email_day_before" [checked]="bookingNotiSettings.get('email_day_before')?.value" />
                <label class="form-check-label c-p" for="summary_mail_every_morning">
                  Send me an email the day before a booking with the school’s
                  details.
                </label>
              </div>
              <div class="form-check">
                <input class="form-check-input c-p" type="checkbox" id="confirmation_every_booking"
                  formControlName="sundays_with_breakdown" />
                <label class="form-check-label c-p" for="confirmation_every_booking">
                  Send me an email on Sundays with a breakdown of my upcoming
                  bookings for the week.
                </label>
              </div> -->

              <div class="form-check">
                <input class="form-check-input c-p" type="checkbox" id="confirmation_of_booking_made_by_staff"
                  formControlName="sunday_as_reminder_to_update" />
                <label class="form-check-label c-p" for="confirmation_of_booking_made_by_staff">
                  Send me an email on a Sunday as a reminder to update my
                  availability for the coming week.
                </label>
              </div>
              <!-- <div class="form-check">
                <input class="form-check-input c-p" type="checkbox" id="confirmation_of_booking_made"
                  formControlName="reminder_if_29_days" />
                <label class="form-check-label c-p" for="confirmation_of_booking_made">
                  Send me a reminder email if it has been 29 days since I
                  updated my availability.
                </label>
              </div> -->
              <!-- <div class="form-check">
                <input class="form-check-input c-p" type="checkbox" id="sms_priority_label" formControlName="sms" />
                <label class="form-check-label c-p" for="sms_priority_label">
                  Receive an email for each booking request.
                </label>
              </div> -->
            </div>
            <!-- <div class="card px-15 mt-20">
              <p class="user-title">SMS priority</p>
              <div class="form-check mt-20">
                <input class="form-check-input c-p" type="checkbox" id="sms_priority_label" formControlName="sms" />
                <label class="form-check-label c-p" for="sms_priority_label">
                  Receive SMS booking notifications for $4.99/month.
                </label>
              </div>
              <a class="txt-regular clr-cc-vilot ml-25">Learn more</a>
            </div> -->
          </form>

          <button type="button" (click)="SubmitForm()" class="btn pl-20 pr-20 cc_p_btn fs_13 mt-28 btn-sm">
            Save changes
          </button>
        </div>
        <div class="tab-pane fade" [ngClass]="schoolProps.properties.job_only_teacher ? 'show active' : ''"
          id="job-content" role="tabpanel" aria-labelledby="job-tab">
          <!-- Job Notifications Content -->
          <div class="card px-15">
            <div>
              <p class="user-title">ClassCover Jobs Headhunter</p>
              <!-- <p class="txt-regular fs-16 mt-20">
                Allow for your profile to be found by ClassCover Jobs Headhunter
                functionality.
              </p> -->
              <div class="col-md-12 col-sm-6 mt-20">
                <div class="job__alerts d-flex align-items-center mt-10">
                  <div class="mr-20">
                    <p class="txt-regular fs-16">
                      Allow for your profile to be found by ClassCover Jobs Headhunter
                      functionality.
                    </p>
                  </div>
                  <div class="form-check form-switch">
                    <input type="checkbox" role="switch" id="availability-switch-1"
                      class="form-check-input delay-send form__switch_cc c-p" [(ngModel)]="availabilitySwitch1"
                      name="availabilitySwitch1" />
                  </div>
                </div>
              </div>
            </div>
            <div>
              <p class="user-title mt-20">Job alert emails</p>
              <p class="txt-regular fs-16 mt-10">
                Get email alerts when a job near me is posted and meets the
                criteria below:
              </p>
              <div class="col-md-12 col-sm-6 mt-10">
                <div class="job__alerts d-flex align-items-center mt-10">
                  <div class="mr-20">
                    <p class="txt-regular fs-16">
                      Allow us to send email alerts when a job near you is
                      posted.
                    </p>
                  </div>
                  <div class="form-check form-switch">
                    <input type="checkbox" role="switch" id="availability-switch-2"
                      class="form-check-input delay-send form__switch_cc c-p" [(ngModel)]="availabilitySwitch2"
                      name="availabilitySwitch2" />
                  </div>
                </div>
              </div>
            </div>
            <div>
              <p class="txt-regular fs-16 mt-20 grey-2">Job alert frequency</p>
              <div class="job__alerts d-flex flex-wrap align-items-center mt-10">
                @for(data of job_alert_frequency; track data.id) {
                <div class="cus-selectOption mr-20" [ngClass]="{
                    'selected-option': selectedJobAlertFrequency === data.value
                  }" (click)="selectedJobAlertFrequency = data.value" style="cursor: pointer">
                  <p class="txt-regular">{{ data.name }}</p>
                </div>
                }
              </div>
            </div>
            <div>
              <p class="txt-regular fs-16 mt-20 grey-2">School level</p>
              <div class="job__alerts d-flex flex-wrap align-items-center mt-10">
                @for(data of school_level; track data.id) {
                <div class="cus-selectOption mr-20" [ngClass]="{
                    'selected-option': selectedSchoolLevel.includes(data.value)
                  }" (click)="toggleSchoolLevel(data.value)" style="cursor: pointer">
                  <p class="txt-regular">{{ data.name }}</p>
                </div>
                }
              </div>
            </div>
            <div>
              <p class="txt-regular fs-16 mt-20 grey-2">School type</p>
              <div class="job__alerts d-flex flex-wrap align-items-center mt-10">
                @for(data of school_type; track data.id) {
                <div class="cus-selectOption mr-20" [ngClass]="{
                    'selected-option': selectedSchoolType === data.value
                  }" (click)="selectedSchoolType = data.value" style="cursor: pointer">
                  <p class="txt-regular">{{ data.name }}</p>
                </div>
                }
              </div>
            </div>

            <div>
              <p class="txt-regular fs-16 mt-20 grey-2">Job type</p>
              <div class="job__alerts d-flex flex-wrap align-items-center mt-10">
                @for(data of job_type; track data.id) {
                <div class="cus-selectOption mr-20" [ngClass]="{
                    'selected-option': selectedJobType === data.value
                  }" (click)="selectedJobType = data.value" style="cursor: pointer">
                  <p class="txt-regular">{{ data.name }}</p>
                </div>
                }
              </div>
            </div>
            <div class="mt-20">
              <label class="txt-regular fs-16 grey-2" for="post_code">Post code</label>
              <input type="text" class="form-control" placeholder="" [(ngModel)]="postCodes" id="post_code" />
            </div>
            <div>
              <p class="txt-regular fs-16 mt-20 grey-2">Distance</p>
              <div class="job__alerts d-flex flex-wrap align-items-center mt-10">
                @for(data of distance; track data.id) {
                <div class="cus-selectOption mr-20" [ngClass]="{
                    'selected-option': selectedDistance === data.value
                  }" (click)="selectedDistance = data.value" style="cursor: pointer">
                  <p class="txt-regular">{{ data.name }}</p>
                </div>
                }
              </div>
            </div>
            <div>
              <p class="txt-regular fs-16 mt-20 grey-2">Role type</p>
              <div class="job__alerts d-flex flex-wrap gap-2 align-items-center mt-10">
                @for(data of settingsData?.role_type_choice; track data.id) {
                <div class="cus-selectOption" [ngClass]="{
                    'selected-option': selectedRoleType.includes(data.id)
                  }" (click)="toggleRoleType(data.id)" style="cursor: pointer">
                  <p class="txt-regular">{{ data.title }}</p>
                </div>
                }
              </div>
            </div>
          </div>
          <button type="button" (click)="submitJobNotificationSettings()"
            class="btn pl-20 pr-20 cc_p_btn fs_13 mt-28 btn-sm">
            Save changes
          </button>
        </div>
        <div class="tab-pane fade" id="account-content" role="tabpanel" aria-labelledby="account-tab">
          <form [formGroup]="accountSettingsForm">
            <div class="card px-15">
              <p class="user-title">Visibility</p>
              <div class="form-check mt-20">
                <input class="form-check-input c-p" type="checkbox" id="profile_viewable_label"
                  formControlName="profile_viewable" />
                <label class="form-check-label c-p" for="profile_viewable_label">
                  Profile viewable to every school.
                </label>
              </div>
            </div>
            <!-- <div class="card px-15 mt-20">
              <p class="user-title">Teaching role</p>
              <div class="form-check mt-20">
                <input class="form-check-input c-p" type="checkbox" id="permanent_role_label"
                  formControlName="permanent_role" />
                <label class="form-check-label c-p" for="permanent_role_label">
                  I am looking for a permanent teaching role.
                </label>
              </div>
            </div> -->
            <div class="card px-15 mt-20">
              <p class="user-title">Update your email</p>
              <div class="form-group position-relative mt-20">
                <label for="user_email">Email</label>
                <input type="email" readonly class="form-control" id="user_email" formControlName="user_email"
                  [disabled]="true" />
                <span class="position-absolute end-0 top-50 c-p" (click)="openEmailEditModal()"
                  style="margin-right: 10px; margin-top: 5px; cursor: pointer">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="31" fill="currentColor"
                    class="bi bi-pencil-fill" viewBox="0 0 16 32">
                    <path
                      d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
                  </svg>

                </span>
              </div>
            </div>
            @if(!schoolProps.properties.is_qld_teacher){
            <div class="card px-15 mt-20">
              <div class="d-flex s_between align-items-center">
                <div>
                  <h1 class="user-title">Multi-Factor Authentication (MFA)
                    @if(isMfaEnabled){
                    <span class="mfa-enabled fs-12">
                      Enabled
                    </span>}
                  </h1>
                  <p class="txt-regular">Add an extra layer of security to your account.</p>
                </div>
                <div class="flex-end">
                  @if (!isMfaEnabled) {
                  <button class="btn cc_p_btn fs-14" (click)="enableMFA()">Enable MFA</button>
                  }
                  @if (isMfaEnabled) {
                  <button class="fs-14 mfa-disable" (click)="showDisableMFAModal()">Disable</button>
                  }
                </div>
              </div>
            </div>
            }
          </form>
          <button type="button" (click)="SubmitForm()" class="btn pl-20 pr-20 cc_p_btn fs_13 mt-28 btn-sm">
            Save changes
          </button>
        </div>
        <div class="tab-pane fade" id="password-content" role="tabpanel" aria-labelledby="password-tab">
          <!-- Password Reset Content -->
          <div class="card px-15">
            <p class="user-title">Password reset</p>
            <form [formGroup]="passwordResetSettingsForm" autocomplete="off">
              <label for="current_password" class="mt-20">Current Password</label>
              <div class="input__group">
                <input [type]="showCurrentPassword ? 'text' : 'password'" class="form-control"
                  placeholder="Current password" formControlName="current_password" autocomplete="off"
                  id="current_password" />
              </div>
              <label for="new_password" class="mt-20">New Password</label>
              <div class="input__group">
                <input [type]="showNewPassword ? 'text' : 'password'" class="form-control" placeholder="New password"
                  formControlName="new_password" autocomplete="off" id="new_password" />
              </div>
              <label for="confirm_password" class="mt-20">Confirm New Password</label>
              <div class="input__group">
                <input [type]="showConfirmPassword ? 'text' : 'password'" class="form-control"
                  placeholder="Confirm new password" formControlName="confirm_password" autocomplete="off"
                  id="confirm_password" />
              </div>
            </form>
          </div>
          <button type="button" (click)="updatePasswordSubmit()" class="btn pl-20 pr-20 cc_p_btn fs_13 mt-28 btn-sm">
            Change password
          </button>
        </div>
        <div class="tab-pane fade" id="support-content" role="tabpanel" aria-labelledby="support-tab">
          <h5>Live support chat</h5>
          <p>Contact support for help.</p>
        </div>
        <div class="tab-pane fade" id="deactivate-content" role="tabpanel" aria-labelledby="deactivate-tab">
          @if(!this.settingsData?.is_deactivated) {
          <!-- <div class="bookings_on_off_label d-flex align-items-center mb-20">
            <div class="mr-20">
              <p class="txt-regular fs-16">
                🔔 If you want to stop yourself from being booked by schools, we
                recommend you turn off bookings instead of deactivating your
                account.
              </p>
            </div>
            <div class="form-check form-switch">
              <input type="checkbox" role="switch" id="bookings_on_off-switch-1"
                class="form-check-input delay-send form__switch_cc c-p" [(ngModel)]="bookings_on_off"
                (ngModelChange)="onBookingsOnOffChange($event)" name="bookings_on_off" />
            </div>
          </div> -->
          <form [formGroup]="deactivateAccountForm">
            <div class="card px-15">
              <p class="user-title">Select one reason to deactivate</p>
              <div class="mt-20">
                @for(reason of deactivateReasons; track reason.value) {
                <div class="form-check mb-5">
                  <input class="form-check-input" type="radio" [id]="'deactivate_' + reason.value"
                    formControlName="reason" [value]="reason.value" />
                  <label class="form-check-label" [for]="'deactivate_' + reason.value">
                    {{ reason.label }}
                  </label>
                </div>
                }
              </div>
            </div>
          </form>
          <button type="button" (click)="submitDeactivateAccount('deactivated')"
            class="btn pl-20 pr-20 cc_p_btn fs_13 mt-28 btn-sm">
            Deactivate account
          </button>
          }
        </div>
        <div class="tab-pane fade" id="delete-content" role="tabpanel" aria-labelledby="delete-tab">
          <!-- <div class="bookings_on_off_label d-flex align-items-center mb-20">
            <div class="mr-20">
              <p class="txt-regular fs-16">
                🔔 If you want to stop yourself from being booked by schools, we
                recommend you turn off bookings instead of deactivating your
                account.
              </p>
            </div>
            <div class="form-check form-switch">
              <input type="checkbox" role="switch" id="bookings_on_off-switch-1"
                class="form-check-input delay-send form__switch_cc c-p" [(ngModel)]="bookings_on_off"
                (ngModelChange)="onBookingsOnOffChange($event)" name="bookings_on_off" />
            </div>
          </div> -->
          <div class="card px-15">
            <p class="user-title">
              Are you sure you want to delete your ClassCover account?
            </p>
            <img src="assets/images/delete_img.png" alt="Success" class="mb-20 mt-20 pt-20 pb-20 mx-auto d-block"
              style="width: 250px" />
            <p class="user-title">
              {{ this.schoolProps.properties.full_name }}, we're sorry to see
              you go
            </p>
            <p class="txt-regular fs-16 mt-10">
              All data associated with your account will be deleted.
              <!-- Once
              deleted, you will need to request access to this school from the
              account owner. <br /><br />
              If you want to proceed with your account deletion, please confirm
              by entering your email below. -->
            </p>
            <label for="confirm_email" class="mt-20">Email ID</label>
            <div class="input__group">
              <input type="email" class="form-control" placeholder="Enter your email" autocomplete="off" id="email"
                [(ngModel)]="enterEmail" />
            </div>
          </div>
          <button type="button" (click)="submitDeactivateAccount('deleted')"
            class="btn pl-20 pr-20 cc_p_btn fs_13 mt-28 btn-sm">
            Delete account
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #YourEmailEditModalComponent>
  <form>
    <div class="modal-header">
      <h4 class="modal-title" id="exampleModalLabel">Confirm with password</h4>
      <button type="button" (click)="closePasswordModal()" class="btn-close" aria-label="Close"></button>
    </div>
    <form [formGroup]="emailEditForm" (ngSubmit)="confirmEmailEdit()">
      <div class="modal-body pb-0">
        <div class="row align-items-center">
          <div class="col-md-12">
            <p class="txt-regular mb-5">
              To update your email please enter your password.
            </p>
            <input type="password" class="form-control" placeholder="Enter your password" formControlName="password"
              name="password" required />
          </div>
        </div>
      </div>
    </form>
    <div class="modal-footer mt-10">
      <button type="button" (click)="confirmEmailEdit()" class="btn cc_p_btn fs_13">
        Next
      </button>
    </div>
  </form>
</ng-template>
<ng-template #updateEmailModal>
  <form [formGroup]="updateEmailForm">
    <div class="modal-header">
      <h4 class="modal-title" id="exampleModalLabel">Enter new email</h4>
      <button type="button" (click)="closePasswordModal()" class="btn-close" aria-label="Close"></button>
    </div>
    <div class="modal-body pb-0">
      <div class="row align-items-center">
        <div class="col-md-12">
          <p class="txt-regular">Type your new email and confirm it</p>
          <label class="">New Email</label>
          <input type="email" class="form-control" formControlName="new_email" name="new_email" required />
        </div>
        <div class="col-md-12 mt-10">
          <label class="">Confirm Email</label>
          <input type="email" class="form-control" formControlName="confirm_email" name="confirm_email" required />
        </div>
      </div>
    </div>
    <div class="modal-footer mt-10">
      <button type="button" (click)="updateEmail()" class="btn cc_p_btn fs_13">
        Update
      </button>
    </div>
  </form>
</ng-template>
<ng-template #deactivateSuccessModal>
  <div class="modal-body text-center pb-0 pt-30">
    @if(deleteDeactivate !== 'activated') {
    <img src="assets/images/deactivate_img.png" alt="Success" class="mb-20" style="width: 120px" />
    <p class="user-title fs-20">Your account is {{ deleteDeactivate }}</p>
    <p class="txt-regular fs-16 mt-10">
      Your ClassCover account is successfully {{ deleteDeactivate }}. Thanks for
      using ClassCover. Hope to see you back soon.
    </p>
    }@else {
    <p class="user-title fs-20">Your account is activated</p>
    <p class="txt-regular fs-16 mt-10">
      Your ClassCover account is successfully activated. Welcome back!
    </p>
    }
  </div>
  <div class="modal-footer delete_deactive text-center mt-10">
    <button type="button" (click)="deleteDeactivate != 'deactivated' && deleteDeactivate != 'activated' ? redirectToLogin() : bsModalRef.hide()"
      class="btn cc_p_btn fs_13">
      Okay
    </button>
  </div>
</ng-template>
<ng-template #MFAVerificationModalTemplate>
  <div class="modal-header">
    <h4 class="model_headings" id="modal-basic-title">
      Multi-Factor Authentication (MFA)
    </h4>
    <button type="button" (click)="bsModalRef.hide()" class="btn-close" aria-label="Close"></button>
  </div>
  <hr>
  <div class="modal-body pb-0">
    <div class="fs-14 txt-regular mb-3 verify-border">
      <p class="fw-semibold">Verification code sent!</p>
      <p class="">We've sent a 6-digit to <span class="fw-semibold">{{ userEmail }}</span></p>
    </div>
    <div class="form-group mt-10">
      <label class="form-check-label c-p">
        Enter the code emailed to you
      </label>
      <input type="text" placeholder="Enter code" maxlength="6" class="form-control otp-input" [(ngModel)]="otpCode"
        (ngModelChange)="onOtpChange()" placeholder="000000" />
    </div>
    <div class="text-center mt-30">
      <span class="fs-14 txt-regular">Didn't receive the code?</span>
      <a class="fs-14 clr-cc-vilot c-p" (click)="resendOtp()">
        Resend
      </a>
    </div>
  </div>
  <hr>
  <div class="modal-footer">
    <button type="button" class="" (click)="bsModalRef.hide()">
      Cancel
    </button>
    <button type="submit" class="fs-14 cc_p_btn disabled" [ngClass]="{'disabled': !isOtpValid}"
      (click)="verifyAndEnableMFA()">
      Verify & Enable
    </button>
  </div>
</ng-template>
<ng-template #DisableMFAModalTemplate>
  <div class="modal-header">
    <h4 class="model_headings" id="editProfileInformationModal">
      Disable Multi-Factor Authentication
    </h4>
    <button type="button" (click)="bsModalRef.hide()" class="btn-close" aria-label="Close"></button>
  </div>
  <hr>
  <div class="modal-body pb-0">
    <p>Are you sure you want to disable two-factor authentication?</p>
  </div>
  <hr>
  <div class="modal-footer">
    <button type="button" class="" (click)="bsModalRef.hide()">
      Cancel
    </button>
    <button type="submit" class="btn cc_p_btn" (click)="disableMFA()">
      ok
    </button>
  </div>
</ng-template>